<template>
  <div class="mb-3" @click="onClick">
    <div
      :class="[
        containerClass,
        { 'tag-badge-reverse': reverse, 'tag-badge-info': !reverse },
      ]"
    >
      <div v-if="HasIcon" class="dot text-center" :class="bgIcon">
        <i class="title-icon" :class="[icon, { 'is-big-icon': isBigIcon }]" />
      </div>
      <span
        class="tag-badge-title-info pb-0"
        :class="[titleClass, { 'pl-2': HasIcon, 'pl-3': !HasIcon }]"
      >
        {{ content }} {{ title }}
      </span>
    </div>
    <div
      v-if="hasLine"
      class="dropdown-divider mt-0 pb-2 ml-3"
      :class="{ line: containerClass.includes('mb') }"
    />
  </div>
</template>
<script>
export default {
  name: 'SectionTitle',
  props: {
    title: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: undefined,
    },
    hasLine: {
      type: Boolean,
      default: () => false,
    },
    reverse: {
      type: Boolean,
      default: () => false,
    },
    containerClass: {
      type: String,
      default: '',
    },
    titleClass: {
      type: String,
      default: '',
    },
    isBigIcon: {
      type: Boolean,
      default: false,
    },
    bgIcon: {
      type: String,
      default: '',
    },
  },
  computed: {
    HasIcon() {
      return !(this.icon === undefined);
    },
  },
  methods: {
    onClick() {
      this.$emit('on-click');
    },
  },
};
</script>

<style scoped>
.tag-badge-info {
  height: auto;
  padding: 0rem 1.2rem 0rem 0rem;
  display: inline-block;
  justify-content: space-between;
}
.tag-badge-success {
  background: #ffedbb no-repeat padding-box;
}
.tag-badge-main-info {
  background: #f5eee9 no-repeat padding-box;
  margin: 50px 0px 30px 0px;
}
.tag-badge-title-info {
  border-radius: 28px;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  letter-spacing: 0;
  color: #11291b;
  display: inline-block;
  padding-left: 1rem;
  margin-top: 5px;
}
.dot {
  background-color: #ff7058;
  box-shadow: 0px 3px 6px #00000029;
  margin: 2px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border-style: solid;
  border-width: 3px;
  border-color: #fff;
  display: inline-block;
}
.dot.green {
  background-color: #2db782;
}
.dot.gray {
  background-color: #3f5b60;
}
.tag-badge-success .dot {
  background: #2eb882 0% 0% no-repeat padding-box;
}
.success {
  background: #2eb882 0% 0% no-repeat padding-box;
}
.title-icon {
  font-size: 1rem;
  color: #fff;
  vertical-align: middle;
}
.line {
  position: relative;
  top: -24px;
}
/* style for reverse gradient. */
.tag-badge-reverse {
  display: inline-flex;
  padding-right: 1em;
  padding: 0rem 1.2rem 0rem 0rem;
  background: transparent -webkit-gradient(
      linear,
      left top,
      right top,
      from(#ffffff),
      to(#e8e8e8)
    ) 0% 0% no-repeat padding-box;
  background: transparent linear-gradient(90deg, #ffffff 0%, #e8e8e8 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 26px;
}
</style>
